import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import DiscountMappingContMain from "presentation/view/container/DiscountMapping/DiscountMappingContMain";

CommonEntrypoint(<DiscountMappingContMain/>)